import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faFlag, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { ViewCourse, ViewCourseDefaultValues } from 'src/app/components/course/course';
import { CourseStatus } from 'src/app/components/course/course-status';
import { AuthService } from 'src/app/services/auth.service';
import { CourseService } from 'src/app/services/course.service';
import { FileService } from 'src/app/services/file.service';
import { ModalService } from 'src/app/services/modal.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-view-course',
    templateUrl: './view-course.component.html',
    styleUrls: ['./view-course.component.scss'],
    standalone: false
})
export class ViewCourseComponent {
  course: ViewCourse = ViewCourseDefaultValues();
  id: string = '';
  coursematerial: any[] = [];
  materialcolumnsToDisplay = ['id', 'name', 'type', 'lang', 'status'];
  imageURL: string | undefined;

  modalSub!: Subscription;
  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  auditLogs: any[] = [];
  pageName = CheckPageAccess.COURSES;
  showeditbutton = this.authservice.getAccessControl().editCourse;
  isMaterialClickable: boolean = false;
  information: string = '';
  faFlag: IconDefinition = faFlag;
  gettingStartedClass: string = '';

  constructor(private courseservice: CourseService,
    private route: ActivatedRoute,
    private fileservice: FileService,
    private router: Router,
    private toastservice: ToastService,
    private _modalservice: ModalService,
    private authservice: AuthService) {
  }

  ngOnInit(): void {
    this.information="<h4>Status Definitions</h4>"+
    "<br/><span>Draft:</span> Material is in progress and not yet finalized. It can be edited and is not visible to participants. It can be associated with a draft course.<br/><br/>"+
    "<span>Published:</span> Material is finalized and available for use in published courses. It can be edited if it is associated with draft courses or published courses with zero enrolments.<br/><br/>"+
    "<span>Retired:</span> Material is no longer actively used for new courses but remains accessible to users who started using it while it was in the published status. It cannot be edited.";

    this.route.params.subscribe({
      next: (params) => {
        this.id = params['id'];
        this.courseservice.getCourseDetailsById(this.id).subscribe({
          next: (response) => {
            this.course = response;
            this.coursematerial = response.materialList;
            this.openThumbnailImage(this.course.courseThumbnailIconId);

            console.log(this.course.courseType)
            if (this.course.courseType == 'Getting Started') {
              this.gettingStartedClass = 'getting-started';
            } else {
              this.gettingStartedClass = '';
            }
          }
        });
      }
    });

    this.courseservice.getCourseAuditLogs(this.id).subscribe({
      next: (logs) => {
        this.auditLogs = logs;
      }
    });

    this.isMaterialClickable = this.authservice.getAccessControl().materials
    this.afterConfirmModalOps();
  }

  openThumbnailImage(id: any) {
    this.fileservice.downloadFile(id).subscribe({
      next: (response) => {
        this.imageURL = response.url;
      }
    })
  }

  deleteCourse() {
    this.askConfirmation('Yes, Delete', 'YESDELETE', 'No, Cancel', 'NO', 'Are you sure you want to delete this course', 'Delete Course');
  }

  askConfirmation(okButtonText: string,
    okButtonValue: string,
    cancelButtonText: string,
    cancelButtonValue: string,
    content: string,
    title: string) {
      this.modalContent = content;
      this.modalTitle = title;
      this.modalOkButtonValue = okButtonValue;
      this.modalCancelButtonValue = cancelButtonValue;
      this.modalOkButtonText = okButtonText;
      this.modalCancelButtonText = cancelButtonText;

      this._modalservice.openModal();
  }

  afterConfirmModalOps() {
    this.modalSub = this._modalservice
      .getButtonClicked()
      .subscribe((button) => {
        switch (button) {
          case 'YESDELETE':
            this.courseservice.deleteCourse(this.id).subscribe({
              next: (response) => {
                this.toastservice.showMessage("Record has been deleted");
                this.router.navigateByUrl('/course-list');
              }
            });
            break;
          case 'YESEDIT':
            this.courseservice.changeCourseStatusFromPublishedToDraft(this.id).subscribe({
              next: (resp) => {
                this.router.navigate(['/edit-course', this.id]);
              }
            });
            break;
          case 'NO':
            this._modalservice.closeModal();
            break;
          default:
            this._modalservice.closeModal();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalSub) {
      this.modalSub.unsubscribe();
    }
  }

  navigatetoEdit() {
    if (this.course.courseStatusId == CourseStatus.PUBLISHED) {
      this.courseservice.hasEnrolledUsers(this.id).subscribe({
        next: (response) => {
          if (response) {
            this.router.navigate(['/edit-course', this.id]);
          } else {
            this.askConfirmation('Yes, Edit', 'YESEDIT', 'No, Cancel', 'NO', 'To edit a published course without any active participants, it will be changed from Published to Draft. Do you want to continue?', 'Edit Published Course');
          }
        }
      });
    } else {
      this.router.navigate(['/edit-course', this.id]);
    }
  }
}
